import { jsxs as n, jsx as i } from "react/jsx-runtime";
import { tv as p } from "tailwind-variants";
import { H as m } from "./chunks/index-UjijAVoZ.js";
const _ = p({
  slots: {
    wrapper: [
      "bg-no-repeat",
      "flex",
      "flex-col",
      "gap-6",
      "items-center",
      "px-6",
      "py-8",
      "text-center",
      "text-lg",
      "rounded-lg",
      "[background-image:theme(backgroundImage.patternSquiggle),theme(backgroundImage.patternBracket),theme(backgroundImage.patternDots)]",
      "[background-position:top_10%_left_-10%,top_-6rem_right_15%,bottom_-0.5rem_right_-0.5rem]",
      "tablet:[background-position:top_50%_left_-10%,top_-5rem_right_10%,bottom_-0.5rem_right_-5px]",
      "desktop:[background-position:top_50%_left_0,_top_-4rem_right_15%,bottom_-0.5rem_right_-5px]"
    ],
    heading: []
  },
  variants: {
    theme: {
      dark: {
        wrapper: ["bg-blue-800", "text-white"],
        heading: ["text-white"]
      },
      light: {
        wrapper: ["bg-gray-100", "text-neutral-500"],
        heading: ["text-neutral-900"]
      }
    }
  }
}), c = ({ className: t, children: e, heading: r, theme: a }) => {
  const { wrapper: o, heading: g } = _({ theme: a });
  return /* @__PURE__ */ n("section", { className: o({ class: t }), children: [
    /* @__PURE__ */ i(m, { className: g(), level: "3", tagName: "h2", children: r }),
    e
  ] });
};
export {
  c as default
};
